import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateVersionFetchFailedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSION_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateVersionFetchFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSION_FETCH_FAILED',
	payload,
});
